import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import requiredIf from "react-required-if";

import { EqualHeightElement } from "../EqualHeight/EqualHeightElement";
import { Heading } from "../Heading";

import styles from "./ProductTile.scss";

const ProductTileTitle = forwardRef(
  ({ children, tag, placeholder, customClass, ...restProps }, ref) => {
    return (
      <EqualHeightElement name="ProductTileTitle" placeholder={placeholder}>
        <div ref={ref} className={cx(customClass)} {...restProps}>
          <Heading
            variants={[
              Heading.Variant.quaternary,
              Heading.Variant.display,
              styles.title,
            ]}
            tag={tag}
            isResponsive={false}
          >
            {children}
          </Heading>
        </div>
      </EqualHeightElement>
    );
  }
);

ProductTileTitle.displayName = "ProductTile.Title";

ProductTileTitle.propTypes = {
  children: requiredIf(
    PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
    (props) => !props.placeholder
  ),
  placeholder: EqualHeightElement.propTypes.placeholder,
  customClass: PropTypes.string,
  tag: PropTypes.string,
};

ProductTileTitle.defaultProps = {
  children: undefined,
  placeholder: EqualHeightElement.defaultProps.placeholder,
  customClass: undefined,
  tag: "p",
};

export default ProductTileTitle;
